import { render } from "./PaginationComponent.vue?vue&type=template&id=d937ff5c&scoped=true"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"

import "./PaginationComponent.vue?vue&type=style&index=0&id=d937ff5c&scoped=true&lang=css"
import "./PaginationComponent.vue?vue&type=style&index=1&id=d937ff5c&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d937ff5c"]])

export default __exports__